/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { server, urlBase, radiusEndpointBase, remoteManagerEndpointBase } from "./Endpoint";

const common = {
  server: server,
  urlBase: urlBase,
  radiusEndpointBase: radiusEndpointBase,
  remoteManagerEndpointBase: remoteManagerEndpointBase,
  storageTokenKey: "smartwifi-jwt-token",
};

const production = {
  ...common,
  routeBase: "",
  debug: false
};

const development = {
  ...common,
  urlBase: "http://localhost:3000",
  routeBase: "",
  debug: true
};

export const constants = process.env.NODE_ENV === "development" ? development : production;
